import request from '@/utils/request'

const urlApi = {
  Login: '/index/login/Login/login',
  Logout: '/index/login/Login/logout',
  ForgePassword: '/index/auth/forge-password',
  Register: '/index/auth/register',
  twoStepCode: '/index/auth/2step-code',
  SendSms: '/index/account/sms',
  SendSmsErr: '/index/account/sms_err',
  // get my info
  UserInfo: '/index/login/Login/info',
  systemConfig: '/index/login/Login/systemConfig'
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login (parameter) {
  return request({
    url: urlApi.Login,
    method: 'post',
    data: parameter
  })
}

export function getSmsCaptcha (parameter) {
  return request({
    url: urlApi.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return request({
    url: urlApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getCurrentUserNav () {
  return request({
    url: urlApi.UserMenu,
    method: 'get'
  })
}

export function logout () {
  return request({
    url: urlApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * get studentmanage 2step code open?
 * @param parameter {*}
 */
export function get2step (parameter) {
  return request({
    url: urlApi.twoStepCode,
    method: 'post',
    data: parameter
  })
}


/**
 * 获取系统配置
 */
export function systemConfig () {
  return request({
    url: urlApi.systemConfig,
    method: 'get'
  })
}
